/**
 * A no-operation function that does nothing and returns undefined.
 */
export const noop = (): void => {}
